function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,18.288a.653.653,0,0,0,.658.645,7.758,7.758,0,0,1,3.518.744,10.284,10.284,0,0,0,4.039.863,10.276,10.276,0,0,0,4.042-.863,8.971,8.971,0,0,1,3.528-.76,8.937,8.937,0,0,1,3.516.76,9.142,9.142,0,0,0,4.041.848.645.645,0,1,0,0-1.289,7.763,7.763,0,0,1-3.522-.745c-.048-.02-.094-.033-.142-.053L23.81,13.41a.632.632,0,0,0,.14-.7.641.641,0,0,0-.6-.4H18.887L17.445,8.455a.645.645,0,0,0-.58-.354H14.833L13.391,5.237a.647.647,0,0,0-.58-.356H3.082a.647.647,0,0,0-.552.307.634.634,0,0,0-.029.625L3.6,8l.054.127-.11.079c-.107.076-.453,1.611-1.5,3.758l-.173.35H.649a.639.639,0,0,0-.526.269.631.631,0,0,0-.089.579l1.211,4.5c-.189-.009-.38-.016-.587-.016A.652.652,0,0,0,0,18.288ZM12.41,6.168,13.383,8.1H5.1L4.131,6.168ZM4.294,9.387h12.17l.972,2.924H3.32ZM21.785,13.6l-3.453,4.389a9.7,9.7,0,0,0-2.549-.36,10.3,10.3,0,0,0-4.045.863,8.962,8.962,0,0,1-3.527.76,8.921,8.921,0,0,1-3.515-.76,9.812,9.812,0,0,0-2.038-.666L1.549,13.6Z",
  transform: "translate(0 -4.881)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.342,22.685a7.714,7.714,0,0,1-3.522-.751,10.212,10.212,0,0,0-4.037-.87,10.231,10.231,0,0,0-4.045.87,8.907,8.907,0,0,1-3.527.767A8.866,8.866,0,0,1,4.7,21.934a9.054,9.054,0,0,0-4.038-.853.65.65,0,1,0,0,1.3,7.71,7.71,0,0,1,3.518.75A10.217,10.217,0,0,0,8.215,24a10.21,10.21,0,0,0,4.042-.87,8.913,8.913,0,0,1,3.528-.766,8.88,8.88,0,0,1,3.516.766,9.084,9.084,0,0,0,4.041.854.65.65,0,1,0,0-1.3Z",
  transform: "translate(0 -5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15.748,16.351h1.79a.665.665,0,0,0,0-1.33h-1.79a.665.665,0,0,0,0,1.33Z",
  transform: "translate(0 -4.949)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M11.559,16.351h1.79a.665.665,0,0,0,0-1.33h-1.79a.665.665,0,1,0,0,1.33Z",
  transform: "translate(0 -4.949)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/yacht.c2323f2b.svg";
export { SvgComponent as ReactComponent };